import { DeviceType, WebviewError, Action } from '../../types';
import { findPlatformType } from '../../util/find-platform-type';
import * as actionTypes from '../action-types';

export function setEquipmentType(value: string): Action<string> {
  return {
    type: actionTypes.EQUIPMENT_TYPE,
    value,
  };
}

export function setError(error: string): Action<string> {
  return {
    type: actionTypes.DASHBOARD_ERROR,
    value: error,
  };
}

export function setWebviewError(error: WebviewError): Action<WebviewError> {
  return {
    type: actionTypes.WEBVIEW_ERROR,
    value: error,
  };
}

export function setWebviewErrorMsg(value: string): Action<string> {
  return {
    type: actionTypes.WEBVIEW_ERROR_MSG,
    value,
  };
}

export function setDeviceType(value: string): Action<string> {
  return {
    type: actionTypes.DEVICE_TYPE,
    value,
  };
}

export function setPlatform(height: string, deviceTypeParam?: DeviceType): Action<string> {
  const determinedPlatform = findPlatformType(height, deviceTypeParam);

  return {
    type: actionTypes.PLATFORM,
    value: determinedPlatform,
  };
}
